import { render, staticRenderFns } from "./NavChip.vue?vue&type=template&id=7492f488"
import script from "./NavChip.vue?vue&type=script&lang=js"
export * from "./NavChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports